import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import './BrandAdminLogin.css';

const BrandAdminLogin = () => {
  const { slug } = useParams();
  const { loginBrandAdmin, brandAdminSlug } = useAuth();
  const navigate = useNavigate();
  const [brand, setBrand] = useState(null);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (brandAdminSlug === slug) { navigate(`/${slug}/admin`); return; }
    const fetch = async () => {
      try {
        const snap = await getDoc(doc(db, 'brands', slug));
        if (snap.exists()) setBrand({ id: snap.id, ...snap.data() });
      } catch {}
    };
    fetch();
  }, [slug, brandAdminSlug, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const snap = await getDoc(doc(db, 'brands', slug));
      if (snap.exists()) {
        const data = snap.data();
        if (loginBrandAdmin(slug, password, data.adminPassword)) {
          toast.success('Welcome!');
          navigate(`/${slug}/admin`);
        } else {
          toast.error('Incorrect password');
        }
      }
    } catch { toast.error('Login failed'); }
    setLoading(false);
  };

  const primary = brand?.primaryColor || '#111';

  return (
    <div className="bal-page" style={{ background: primary }}>
      <div className="bal-card">
        <div className="bal-logo" style={{ background: primary }}>
          {brand?.logoUrl ? <img src={brand.logoUrl} alt={brand.name} /> : <span>{brand?.name?.slice(0,2).toUpperCase() || '??'}</span>}
        </div>
        <h2>{brand?.name || 'Brand'} Admin</h2>
        <p>Enter your admin password to manage this catering site.</p>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input type="password" className="form-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter admin password" autoFocus />
          </div>
          <button type="submit" className="bal-btn" disabled={loading} style={{ background: primary, borderColor: primary }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <a href={`/${slug}`} className="bal-back">← Back to {brand?.name || 'catering site'}</a>
      </div>
    </div>
  );
};

export default BrandAdminLogin;
